
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PaymentRequestModel } from '@/models/payment-request';
import { BillOfLadingModel } from '@/models/bill-of-lading';

@Component
export default class ListOrder extends Vue {
    private eventEmit = {
        eventChangeData: 'eventChangeData'
    };

    @Prop({default: []})
    private orders!: BillOfLadingModel[];
    @Prop({default: null})
    private paymentRequest!: PaymentRequestModel;
    private isCheckAll = false;

    onSelectedProduct(index: number) {
        this.orders[index].isChecked = !this.orders[index].isChecked;
        this.$emit(this.eventEmit.eventChangeData, {
            orders: this.orders.filter(x => x.isChecked === true) || []
        });
    }

    private async onCheckAllOrder() {
        this.$emit('eventCheckAll', this.isCheckAll);
    }
}
